import React, { useState, useEffect } from "react";
import { MDBRow, MDBCol, MDBInput, MDBBtn, MDBContainer } from "mdbreact";

import Axios from "axios";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from "../components/WarningBox";

import { Bounce, ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import Spinner from "../components/Spinner";
const AddEditVehicleCustomer = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  const serverURL = props.apiServer;

  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [showPreloader, setPreloader] = useState("normal");

  const [frm, setValues] = useState({
    code: "new",
    make: { value: "0", label: "[No Brand]" },
    yearmodel: new Date().getUTCFullYear(),
    plateno: "",
    conductionsticker: "NOT SPECIFIED",
    fueltype: { value: "0", label: "[NOT SPECIFIED]" },
    mileage: "0",
    chassisno: "NOT SPECIFIED",
    engineno: "NOT SPECIFIED",
    variant: "",
    deleted: false,
    datecreated: new Date(),
    usertoken: sessionStorage.getItem("msal.uc"),
  });
  const toastId = React.useRef(null);

  const notify = (message) => {
    toast(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold blue-text",
    });
  };

  const warning = (message) => {
    toast.error(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold white-text",
    });
  };
  const [makeoptions, setmakeoptions] = useState([]);
  const loadmakeoption = () => {
    Axios.get(serverURL + "/getmakeoptions", bearer)
      .then((res) => {
        setmakeoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [fueltypeoptions, setfueltypeoptions] = useState([]);
  const loadfueltypeoption = () => {
    Axios.get(serverURL + "/getfueltypeoptions", bearer)
      .then((res) => {
        setfueltypeoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };
  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;

      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    savevehicle();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const loadvehicledetails = () => {
    setPreloader("normal");
    Axios.get(
      props.apiServer + "/loadvehicledetails?acode=" + props.code,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,
            code: props.code,

            make: { value: res.data.carmakecode, label: res.data.carmake },
            yearmodel: res.data.yearmodel,
            plateno: res.data.plateno,
            conductionsticker: res.data.conductionsticker,
            fueltype: {
              value: res.data.fueltypecode,
              label: res.data.fueltype,
            },
            mileage: res.data.mileage,
            chassisno: res.data.chassisno,
            engineno: res.data.engineno,
            variant: res.data.variant,
            deleted: res.data.deleted,
          });
          setPreloader("none");
        } else {
          // console.log("No record");
          setPreloader("none");
        }
      })

      .catch((error) => {
        // setErrorMessage(error);
        warning("Failed to load record.");
      });
    // setPreloader("none");
  };

  const savevehicle = () => {
    const data = frm;
    setPreloader("normal");
    Axios.post(props.apiServer + "/savemyvehicle", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });
          notify(res.data.message);

          if (props.code === "") {
            props.toggleModal();
          }

          setPreloader("none");
        } else {
          warning(res.data.message);
          setPreloader("none");
        }
      })
      .catch((error) => {
        warning(error);
        setPreloader("none");
      });
  };
  useMountEffect(loadmakeoption);
  useMountEffect(loadfueltypeoption);
  useMountEffect(loadvehicledetails);

  return (
    <React.Fragment>
      {showPreloader === "normal" ? (
        <Spinner />
      ) : (
        <MDBContainer fluid>
          <MDBRow>
            <MDBCol md="10">
              <form
                className="needs-validation"
                onSubmit={submitHandler}
                noValidate
              >
                <MDBRow hidden>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.code}
                      id="code"
                      label="code"
                      required
                      onChange={updateField}
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md="10" className="text-left">
                    <label className="grey-text">
                      <small>&nbsp;Make</small>
                    </label>
                    <br />
                    <Select
                      placeholderText="Make"
                      isSearchable
                      value={frm.make}
                      onChange={handleChange("make")}
                      options={makeoptions}
                      required
                    />

                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback">Looks good!</div>

                    <br />
                  </MDBCol>

                  {/* <MDBCol md="2" className="ml-0 pt-4">
                  <MDBBtn
                    size="sm"
                    onClick={toggleVehicleOption}
                    className="grey lighten-5 brown-text"
                  >
                    <MDBIcon icon="plus" />
                  </MDBBtn>
                </MDBCol> */}
                </MDBRow>

                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.variant}
                      id="variant"
                      label="Variant"
                      required
                      onChange={updateField}
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.yearmodel}
                      id="yearmodel"
                      label="Year Model"
                      required
                      type="number"
                      onChange={updateField}
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>

                {/* <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.conductionsticker}
                      id="conductionsticker"
                      label="Conduction Sticker"
                      onChange={updateField}
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow> */}

                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.plateno}
                      id="plateno"
                      label="Plate Number"
                      onChange={updateField}
                    ></MDBInput>
                  </MDBCol>
                </MDBRow>

                {/* <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.chassisno}
                      id="chassisno"
                      label="Chassis No"
                      onChange={updateField}
                    ></MDBInput>
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.engineno}
                      id="engineno"
                      label="Engine No"
                      onChange={updateField}
                    ></MDBInput>
                  </MDBCol>
                </MDBRow> */}

                {/* <MDBRow>
                  <MDBCol md="10" className="text-left">
                    <label className="grey-text">
                      <small>&nbsp;Fuel Type</small>
                    </label>
                    <br />
                    <Select
                      placeholderText="Fuel Type"
                      isSearchable
                      value={frm.fueltype}
                      onChange={handleChange("fueltype")}
                      options={fueltypeoptions}
                      required
                    />
                  </MDBCol>
                </MDBRow> */}
                {/* <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.mileage}
                      id="mileage"
                      label="Mileage (KM)"
                      onChange={updateField}
                      type="number"
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow> */}
                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      id="deleted"
                      label="Is Deleted"
                      type="checkbox"
                      checked={frm.deleted}
                      onChange={updateField}
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol md="12">
                    <MDBBtn className="blue lighten-1" type="submit">
                      Save
                    </MDBBtn>
                    {props.code === "" ? (
                      <>
                        <MDBBtn
                          id="cmdClose"
                          className="blue lighten-4 blue-text"
                          onClick={props.toggleModal}
                        >
                          Close this
                        </MDBBtn>
                      </>
                    ) : (
                      ""
                    )}
                  </MDBCol>
                  <MDBCol md="6"></MDBCol>
                </MDBRow>
              </form>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      ></ToastContainer>
      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditVehicleCustomer;
